import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3c29a280")

_pushScopeId("data-v-3c29a280")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-m-4" }
const _hoisted_3 = { class: "kn-material-input-label" }
const _hoisted_4 = { class: "p-d-flex p-flex-row p-jc-between" }
const _hoisted_5 = { class: "input-help p-m-0" }
const _hoisted_6 = { class: "p-m-4" }
const _hoisted_7 = { class: "kn-material-input-label" }
const _hoisted_8 = { class: "p-d-flex p-flex-row p-jc-between" }
const _hoisted_9 = { class: "input-help p-m-0" }
const _hoisted_10 = { class: "p-m-4" }
const _hoisted_11 = { class: "kn-material-input-label" }
const _hoisted_12 = { class: "p-d-flex p-flex-row p-jc-between" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_14 = { class: "input-help p-m-0" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Dialog, {
      header: _ctx.$t('workspace.myAnalysis.editAnalysis'),
      style: _ctx.workspaceAnalysisViewEditDialogDescriptor.dialog.style,
      visible: _ctx.visible,
      modal: true,
      class: "p-fluid kn-dialog--toolbar--primary",
      closable: false
    }, {
      footer: _withId(() => [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.closeDialog
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          disabled: _ctx.saveButtonDisabled,
          onClick: _ctx.saveAnalysis
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      default: _withId(() => [
        (_ctx.analysis)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode("span", null, [
                  _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('common.label')) + " *", 1),
                  _createVNode(_component_InputText, {
                    class: ["kn-material-input p-inputtext-sm", {
                                'p-invalid': _ctx.labelDirty && (!_ctx.analysis.label || _ctx.analysis.label.length === 0)
                            }],
                    modelValue: _ctx.analysis.label,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.analysis.label = $event)),
                    maxLength: _ctx.workspaceAnalysisViewEditDialogDescriptor.labelMaxLength,
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.labelDirty = true)),
                    onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.labelDirty = true))
                  }, null, 8, ["modelValue", "class", "maxLength"])
                ]),
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", null, [
                    _withDirectives(_createVNode("div", { class: "p-error p-grid p-m-2" }, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('common.label') })), 513), [
                      [_vShow, _ctx.labelDirty && (!_ctx.analysis.label || _ctx.analysis.label.length === 0)]
                    ])
                  ]),
                  _createVNode("p", _hoisted_5, _toDisplayString(_ctx.labelHelp), 1)
                ])
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode("span", null, [
                  _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('common.name')) + " *", 1),
                  _createVNode(_component_InputText, {
                    class: ["kn-material-input p-inputtext-sm", {
                                'p-invalid': _ctx.nameDirty && (!_ctx.analysis.name || _ctx.analysis.name.length === 0)
                            }],
                    modelValue: _ctx.analysis.name,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.analysis.name = $event)),
                    maxLength: _ctx.workspaceAnalysisViewEditDialogDescriptor.nameMaxLength,
                    onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.nameDirty = true)),
                    onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.nameDirty = true))
                  }, null, 8, ["modelValue", "class", "maxLength"])
                ]),
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", null, [
                    _withDirectives(_createVNode("div", { class: "p-error p-grid p-m-2" }, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('common.name') })), 513), [
                      [_vShow, _ctx.nameDirty && (!_ctx.analysis.name || _ctx.analysis.name.length === 0)]
                    ])
                  ]),
                  _createVNode("p", _hoisted_9, _toDisplayString(_ctx.nameHelp), 1)
                ])
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode("span", null, [
                  _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('common.description')), 1),
                  _createVNode(_component_InputText, {
                    class: "kn-material-input p-inputtext-sm",
                    modelValue: _ctx.analysis.description,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.analysis.description = $event)),
                    maxLength: _ctx.workspaceAnalysisViewEditDialogDescriptor.descriptionMaxLength
                  }, null, 8, ["modelValue", "maxLength"])
                ]),
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("p", _hoisted_14, _toDisplayString(_ctx.descriptionHelp), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["header", "style", "visible"])
  ]))
})